export default __webpack_public_path__ + "static/media/Exclamation.efe7507c.svg";